import React from "react";
import * as yup from "yup";
import {useFormik} from "formik";
import {Messages} from "app_constants";
import {Modal, Container, Row, Col, Form, Button} from "react-bootstrap";
import Loading from "components/Loading";
import ReqState from "lib/reqstate";
import {TemplateStates} from "./DesignerPage";



export default function DesignerModal({
  initialValues,
  sendingState,
  onSave,
  onClose,
}: {
  initialValues: TemplateStates;
  sendingState: number;
  onSave: (formValues: TemplateStates) => void;
  onClose: () => void;
}) {
  const f = useFormik({
    initialValues: initialValues,
    validationSchema: yup.object().shape({
      name: yup.string().required(Messages.RequireError),
      createCycle: yup.string().required(Messages.SelectError),
      storeCycle: yup.string().required(Messages.SelectError),
    }),
    onSubmit: (formValues) => {
      onSave(formValues)
    }
  });


  function handleLinkedIdChange(e: React.ChangeEvent<HTMLInputElement>) {
    const ids = [...f.values.linkedIds];

    if (e.target.checked) {
      ids.push(e.target.value);
    } else {
      ids.splice(ids.indexOf(e.target.value), 1);
    }

    f.setFieldValue("linkedIds", ids, false);
  }


  return (
    <Modal
      show={true}
      animation={false}
      backdrop="static"
    >
      <Modal.Body>
        <Loading
          isSendError={sendingState == ReqState.ERROR}
          errorMsg={Messages.ServerError}
        />
        <Container>
          <Form onSubmit={f.handleSubmit}>
            <Row className="mb-2 d-flex align-items-center">
              <Col>
                <Form.Label htmlFor="name">名前</Form.Label>
              </Col>
              <Col>
                <Form.Control id="name" type="text" name="name" value={f.values.name} onChange={f.handleChange} isInvalid={f.touched.name && !!f.errors.name} />
                <Form.Control.Feedback type="invalid">{f.errors.name}</Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-2 d-flex align-items-center">
              <Col>
                <Form.Label htmlFor="createCycle">作成周期</Form.Label>
              </Col>
              <Col>
                <Form.Select id="createCycle" name="createCycle" value={f.values.createCycle} onChange={f.handleChange}  isInvalid={f.touched.createCycle && !!f.errors.createCycle}>
                  <option value="">--</option>
                  <option value="day">day</option>
                  <option value="week">week</option>
                  <option value="month">month</option>
                  <option value="year">year</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">{f.errors.createCycle}</Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-2 d-flex align-items-center">
              <Col>
                <Form.Label htmlFor="storeCycle">保存周期</Form.Label>
              </Col>
              <Col>
                <Form.Select id="storeCycle" name="storeCycle" value={f.values.storeCycle} onChange={f.handleChange} isInvalid={f.touched.storeCycle && !!f.errors.storeCycle}>
                  <option value="">--</option>
                  <option value="year">year</option>
                  <option value="all">all</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">{f.errors.storeCycle}</Form.Control.Feedback>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>連携ID</Form.Label>
              </Col>
              <Col>
                <div className="d-flex">
                  <Form.Check type="checkbox" name="linkedIds" id="cid" label="cid" value="cid" checked={f.values.linkedIds.indexOf("cid") >= 0} onChange={handleLinkedIdChange} />
                  { f.values.linkedIds.indexOf("cid") >= 0 &&
                    <span className="ms-2">{f.values.linkedIds.indexOf("cid") + 1}</span>
                  }
                </div>
                <div className="d-flex">
                  <Form.Check type="checkbox" name="linkedIds" id="eid" label="eid" value="eid" checked={f.values.linkedIds.indexOf("eid") >= 0} onChange={handleLinkedIdChange} />
                  { f.values.linkedIds.indexOf("eid") >= 0 &&
                    <span className="ms-2">{f.values.linkedIds.indexOf("eid") + 1}</span>
                  }
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Loading
          isLoading={sendingState == ReqState.DOING}
        >
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button onClick={() => f.handleSubmit()}>保存</Button>
        </Loading>
      </Modal.Footer>
    </Modal>
  )
}
